import { Box, Button, Flex } from '@chakra-ui/react';

export type FilterOption = {
  value: string;
  label: string;
  dotColor?: string;
};

type Props = {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
};

export default function FilterChips({ options, value, onChange }: Props) {
  return (
    <Flex gap={2} wrap='wrap'>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <Button
            key={opt.value}
            size='sm'
            variant={isActive ? 'solid' : 'outline'}
            bg={isActive ? 'gray.900' : 'white'}
            color={isActive ? 'white' : 'gray.800'}
            borderColor={isActive ? 'gray.900' : 'gray.200'}
            borderRadius='full'
            fontWeight='medium'
            fontSize='xs'
            px={3}
            onClick={() => onChange(opt.value)}
            _hover={{
              bg: isActive ? 'gray.800' : 'gray.50',
            }}
          >
            {opt.dotColor && (
              <Box
                as='span'
                display='inline-block'
                w='6px'
                h='6px'
                borderRadius='full'
                bg={opt.dotColor}
                mr={1.5}
              />
            )}
            {opt.label}
          </Button>
        );
      })}
    </Flex>
  );
}
